// ButtonWithProgress.js tick with add
import React from 'react';
import CircularProgress from "@mui/material/CircularProgress";
const ButtonWithProgress = ({   buttonClass, onClick }) => {
  return (
    <button type="button" className={`btn ${buttonClass}`} onClick={onClick}>
      <CircularProgress
                          style={{
                            color: "white",
                            width: "17px",
                            height: "auto",
                          }}
                        />
    </button>
  );
};

export default ButtonWithProgress;